import { Stack } from '@mantine/core'
import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { useAdminFund } from '@repo/common/queries/admin/fund'

import { TransactionRecordingForm } from '@/components/TransactionRecordingForm'
import { useDynamicTitle, withTitle } from '@/utils/withTitle.ts'

export const Route = createFileRoute('/_app/fund/$id/record-transaction')({
  component: RecordTransactionPage,
  validateSearch: (
    search: Record<string, unknown>,
  ): { side: 'buy' | 'sell'; asset_id?: string } => ({
    side: search.side === 'sell' ? 'sell' : 'buy',
    asset_id: typeof search.asset_id === 'string' ? search.asset_id : undefined,
  }),
  head: withTitle((params) => `Fund ${params.id} - Record Transaction`),
})

function RecordTransactionPage() {
  const { id } = Route.useParams()
  const navigate = useNavigate()
  const { side, asset_id } = Route.useSearch()
  const fund = useAdminFund(id!)

  useDynamicTitle(`${fund.data?.name} - Record Transaction`)

  const handleAssetChange = (newAssetId: string) => {
    void navigate({
      to: '/fund/$id/record-transaction',
      params: { id: id || '' },
      search: { side, ...(newAssetId ? { asset_id: newAssetId } : {}) },
      replace: true,
    })
  }

  const handleSideChange = (newSide: 'buy' | 'sell') => {
    void navigate({
      to: '/fund/$id/record-transaction',
      params: { id: id || '' },
      search: { side: newSide, ...(asset_id ? { asset_id } : {}) },
      replace: true,
    })
  }

  return (
    <Stack>
      <TransactionRecordingForm
        fundId={id!}
        initialSide={side}
        initialAssetId={asset_id}
        onAssetChange={handleAssetChange}
        onSideChange={handleSideChange}
      />
    </Stack>
  )
}
